import { render, staticRenderFns } from "./LoadInformation.vue?vue&type=template&id=4be46ba5&scoped=true"
import script from "./LoadInformation.vue?vue&type=script&lang=js"
export * from "./LoadInformation.vue?vue&type=script&lang=js"
import style0 from "./LoadInformation.vue?vue&type=style&index=0&id=4be46ba5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4be46ba5",
  null
  
)

export default component.exports